<template>
  <div class="flex flex-col grow overflow-y-auto">
    <PassportTitleBar
      ref="titleBarRef"
      :title="title"
      :count="count"
      :showBack="showBack"
      :withSearch="withSearch"
      :viewport="viewport"
      @back="$emit('back')"
    >
      <template v-if="$slots.default" #button="{ isMobile }">
        <slot name="button" :isMobile="isMobile" />
      </template>
    </PassportTitleBar>
    <div :class="cn('flex flex-col grow overflow-y-auto', props.class)">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { PassportTitleBar } from "@/SharedComponents/Passport";
import { cn } from "@/Utils/cn";

defineEmits(["back"]);

const titleBarRef = ref(null);

const props = defineProps({
  title: { type: String, required: true },
  count: { type: [String, Number], required: false },
  showBack: { type: Boolean, default: true },
  withSearch: { type: Boolean, default: false },
  viewport: {
    type: String,
    validator: (val) => ["mobile", "desktop", "reactive"].includes(val),
    default: "reactive",
  },
  class: { type: null, required: false },
});

defineExpose({
  query: computed(() => titleBarRef.value?.query),
  clearQuery: () => titleBarRef.value?.clearQuery(),
});
</script>
